import SignedUrlInterface from "@/interfaces/signedUrl.interface";
import { AxiosInstance } from "axios";
import SignedCookieInterface from "@/interfaces/signedCookie.interface";

export default class AwsService {
    private axios: AxiosInstance;

    constructor(axios: AxiosInstance) {
        this.axios = axios;
    }

    getSignedCookies(storageName: string): Promise<SignedCookieInterface> {
        return new Promise((resolve, reject) => {
            this.axios
                .get(`/assets/signed-cookies/${storageName}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    getSignedUrls(assetUrls: Array<string | undefined>): Promise<SignedUrlInterface[]> {
        return new Promise((resolve, reject) => {
            if (!assetUrls) {
                return reject();
            }

            this.axios
                .post(`assets/signed-urls`, assetUrls)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }
}
